import { render, staticRenderFns } from "./CiProgressNavigation.vue?vue&type=template&id=506344c1&scoped=true&"
import script from "./CiProgressNavigation.vue?vue&type=script&lang=js&"
export * from "./CiProgressNavigation.vue?vue&type=script&lang=js&"
import style0 from "./CiProgressNavigation.vue?vue&type=style&index=0&id=506344c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506344c1",
  null
  
)

component.options.__file = "CiProgressNavigation.vue"
export default component.exports